import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';

interface EscapeClosable {
  isOpen(): boolean;
  close(): void;
}

@Directive({
  selector: 'input[preventClearOnEsc]',
  standalone: true
})
export class PreventClearOnEscDirective implements OnInit, OnDestroy {
  private removeKeydownListener?: () => void;

  @Input('preventClearOnEsc') escapeClosable?: EscapeClosable;

  constructor(private readonly elementRef: ElementRef<HTMLInputElement>) {}

  ngOnInit(): void {
    const input = this.elementRef.nativeElement;
    const onKeydown = (event: KeyboardEvent): void => {
      if (event.key !== 'Escape') {
        return;
      }

      const hasValueToPreserve = input.value.trim().length > 0;
      const isPanelOpen = this.escapeClosable?.isOpen() ?? false;

      if (!hasValueToPreserve && !isPanelOpen) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (isPanelOpen) {
        this.escapeClosable?.close();
      }
    };

    input.addEventListener('keydown', onKeydown, true);
    this.removeKeydownListener = () => input.removeEventListener('keydown', onKeydown, true);
  }

  ngOnDestroy(): void {
    this.removeKeydownListener?.();
  }
}
